import { BrowserRouter, Route, Routes } from "react-router-dom"
import NavigateTo from "../components/routing/NavigateTo"
import PageLayout from "../components/layout/PageLayout"
import NotFound from "../pages/NotFound"
import { routes } from "./Routes"
import { Suspense, lazy } from "react"
import CircularBackdrop from "../components/backdrop/CircularBackdrop"
// import ViewerPage from "../pages/ViewerPage"
import ProjectPage from "../pages/ProjectPage"
import PokedexPage from "../pages/PokedexPage"
// import NftComposer from "../components/layout/NftComposer"
import CurriculmPage from "../pages/CurriculumPage"

const Home = lazy(() => import('../pages/Homepage'))

export default function AppRouter() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <NavigateTo />
      <Suspense fallback={<CircularBackdrop open />}>
        <Routes>
          <Route path={routes.home} element={<PageLayout />}>
            <Route index element={<Home />} />
          </Route>
          <Route path={`${routes.home}:projectId`} element={<PageLayout />}>
            <Route index element={<ProjectPage />} />
          </Route>
          {/* <Route path={routes.curriculum} >
            <Route index element={<CurriculmPage />} />
          </Route> */}
          {/* <Route path={routes.viewer} element={<PageLayout />}>
            <Route index element={<ViewerPage />} />
          </Route> */}
          <Route path={routes.pokedex} element={<PageLayout />}>
            <Route index element={<PokedexPage />} />
          </Route>
          <Route path='*' element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
